import {useApi} from "../Api";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";
import {
    DeskDiscountGovernanceEntityRequest,
    DeskDiscountGovernanceEntityResponse,
    DeskDiscountGovernanceGetData,
    DeskDiscountGovernanceUpdateRequest,
    FormSearchDeskDiscountGovernanceModel
} from "../types/deskDiscountGovernance";
import dayjs from "dayjs";
import axios from "axios";

export const useDeskDiscountGovernanceRepository = () => {
    const {GET, PUT, DELETE} = useApi();

    const PATH = "/pricing/desk-discount-governance";
    const PATH_LOCATION = "/pricing/location";

    function getDeskDiscountGovernancePaged(filters: FormSearchDeskDiscountGovernanceModel): Promise<PagedResponse<DeskDiscountGovernanceEntityResponse>> {
        const query = "?";
        const queryParams = buildQueryParams(filters);
        return GET(`${PATH}/paged/filter${queryParams ? query + queryParams : ""}`);
    }

    function getDeskDiscountGovernanceDatas(legalEntities: string[], dealers: string[]): Promise<DeskDiscountGovernanceGetData> {
        return GET(`${PATH_LOCATION}/discount-location-view?legalEntities=${legalEntities}${dealers.length > 0 ? '&dealers=' + dealers : ''}`);
    }

    // Create massiva: il BE (proxy verso Pricing /insert) risponde con byte/xlsx (report righe scartate).
    function postDeskDiscountGovernance(request: DeskDiscountGovernanceEntityRequest): Promise<any> {
        return axios.post(`${PATH}/insert`, request, {
            headers: {
                'Content-Disposition': "attachment; filename=template.xlsx",
                'Content-Type': 'application/json'
            },
            responseType: 'arraybuffer',
        });
    }

    // Update singolo record: unico campo modificabile e' active (toggle). Gli altri campi sono
    // echo del record esistente. Full-replace verso Pricing (singleUpdate), id nel body.
    function putDeskDiscountGovernance(request: DeskDiscountGovernanceUpdateRequest): Promise<DeskDiscountGovernanceEntityResponse> {
        return PUT(`${PATH}`, request);
    }

    // Recupera tutte le configurazioni (attive e non) per lo stesso scope logico
    // (location + profilo + dealer + legalEntity), per la lista di toggle nel form di modifica.
    function getDeskDiscountGovernanceByScope(row: DeskDiscountGovernanceEntityResponse): Promise<PagedResponse<DeskDiscountGovernanceEntityResponse>> {
        const queryParams = buildQueryParams({
            locationCodes: row.prcLocation?.id ? [row.prcLocation.id] : [],
            lppProfileIds: [row.idLppProfile],
            dealers: [row.dealer],
            legalEntities: [row.legalEntity],
            size: 500,
            page: 0
        });
        return GET(`${PATH}/paged/filter?${queryParams}`);
    }

    function deleteDeskDiscountGovernance(id: number): Promise<string> {
        return DELETE(`${PATH}?id=${id}`);
    }

    // Recupera le configurazioni ATTIVE dello scope selezionato in creazione (location x profilo x
    // dealer x legal entity), per rilevare le sovrapposizioni prima dell'insert: la creazione di una
    // nuova configurazione attiva disattiva le eventuali parallele attive sullo stesso scope.
    function getActiveGovernanceForScope(params: {
        locationCodes: string[];
        lppProfileIds: number[];
        dealers: string[];
        legalEntities: string[];
    }): Promise<PagedResponse<DeskDiscountGovernanceEntityResponse>> {
        const queryParams = buildQueryParams({
            locationCodes: params.locationCodes,
            lppProfileIds: params.lppProfileIds,
            dealers: params.dealers,
            legalEntities: params.legalEntities,
            active: true,
            size: 1000,
            page: 0
        });
        return GET(`${PATH}/paged/filter?${queryParams}`);
    }

    // Scarica il report xlsx delle righe scartate restituito dalla create massiva.
    function downloadError(response: any) {
        try {
            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet',
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            const title = `desk_discount_governance_error_${dayjs().format("YYYYMMDDHHmm")}.xlsx`;
            a.href = url;
            a.download = `${title}`;
            a.click();
        } catch (e) {
            // ignore
        }
    }

    return {
        getDeskDiscountGovernancePaged,
        getDeskDiscountGovernanceDatas,
        postDeskDiscountGovernance,
        putDeskDiscountGovernance,
        getDeskDiscountGovernanceByScope,
        getActiveGovernanceForScope,
        deleteDeskDiscountGovernance,
        downloadError
    };
};
